<template>
	<AppDialog width="840" disable-max-width closeRight="-10" closeTop="-30" ref="dialog_container" :dialogName="'InstallationDialog'">
		<div class="installation-container flex-centerize flex-column">
			<InstallationContent
				avoidRedirection
				:installableId="installableId"
				:installableVersionId="installableVersionId"
				@installation-complete="openInstallationCompleteDialog"
			/>
		</div>
	</AppDialog>
</template>
<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import InstallationContent from '@/views/Installables/InstallationContent.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
export default {
	name: 'InstallationDialog',
	props: {
		omitResponse: { type: Boolean },
		installableId: { type: String },
		installableVersionId: { type: Number },
		dialogPromiseHandlers: { type: Object },
	},
	components: {
		AppDialog,
		InstallationContent,
	},
	methods: {
		close() {
			this.dialogPromiseHandlers.resolve();
			this.$refs.dialog_container.closeCurrentDialog();
		},
		openInstallationCompleteDialog(installedWorkflow) {
			this.close();
			AppDialogManagerService.openInstallationCompleteDialog({ wfId: installedWorkflow.id });
		},
	},
};
</script>
<style scoped lang="scss">
.installation-container {
	min-height: 840px;
	max-height: 840px;
	border-radius: 10px;
	box-shadow: 0px 3px 6px var(--shadow-color);
	background: var(--setup-node-container-background);
}
</style>
